import { useMutation, useQuery } from "@tanstack/react-query";
import { client } from "./client";

export const useCreateToken = ({ onSuccess, onError } = {}) => {
    return useMutation({
        mutationFn: async (payload) => {
            const response = await client("token/create", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                data: payload,
            });
            return response;
        },
        onSuccess,
        onError,
    });
};

export const useGetAllTokens = () => {
    const token = localStorage.getItem("accessToken");
    return useQuery({
        queryKey: ["allTokens"],
        queryFn: async () => {
            const response = await client("token", {
                method: "GET",
                headers: {
                    Authorization: token ? `Bearer ${token}` : undefined,
                },
            });
            return response;
        },
    });
};

export const useDeleteTokenById = (id) => {
    const token = localStorage.getItem("accessToken");
    const { refetch } = useGetAllTokens();

    return useMutation({
        mutationFn: async () => {
            const response = await client(`token/${id}`, {
                method: "DELETE",
                headers: {
                    Authorization: token ? `Bearer ${token}` : undefined,
                },
            });
            return response;
        },
        onSuccess: () => {
            refetch();
        },
    });
};
